import { useAppSelector } from '../../../Hooks/useAppSelector'
import { CarriersSelectors } from '../StoreAdapter'

export const useCarriersSelector = () => {
  return useAppSelector(CarriersSelectors.selectEntities)
}
